module.exports = __webpack_public_path__ + "assets/img/middle-bg.0a042aed.png";